import {
    SelectedTabQueryParamValues,
    TSelectedTabQueryParamValues,
} from '../types';

import { ExpandedEventInUrl } from '@src/app/enums';
import { IState } from '@app/store';

import { ActionContext } from 'vuex';

export interface EventDetailsState {
    selectedTab: TSelectedTabQueryParamValues;
    isMiniScoreboardVisible: boolean;
    isSmallVisualisationVisible: boolean;
}

const eventDetailsStore = {
    namespaced: true,
    state: {
        selectedTab: SelectedTabQueryParamValues.OFFER,
        isMiniScoreboardVisible: false,
        isSmallVisualisationVisible: false,
    } as EventDetailsState,
    getters: {
        selectedTab: (state: EventDetailsState) => state.selectedTab,
        isMiniScoreboardVisible: (state: EventDetailsState) => state.isMiniScoreboardVisible,
        isSmallVisualisationVisible: (state: EventDetailsState) => state.isSmallVisualisationVisible,
    },
    mutations: {
        SET_SELECTED_TAB(state: EventDetailsState, tab: TSelectedTabQueryParamValues) {
            state.selectedTab = tab;
        },
        SET_IS_MINI_SCOREBOARD_VISIBLE(state: EventDetailsState, value: boolean) {
            state.isMiniScoreboardVisible = value;
        },
        SET_IS_SMALL_VISUALISATION_VISIBLE(state: EventDetailsState, value: boolean) {
            state.isSmallVisualisationVisible = value;
        },
    },
    actions: {
        setSelectedTab({ commit, rootGetters, dispatch }: ActionContext<EventDetailsState, IState>, tab: TSelectedTabQueryParamValues) {
            commit('SET_SELECTED_TAB', tab);

            const { query, path } = rootGetters['navigation/route'];

            dispatch(
                'navigation/replace',
                {
                    query: { ...query, [ExpandedEventInUrl.selectedTab]: tab },
                    path,
                },
                { root: true },
            );
        },
        setIsMiniScoreboardVisible({ commit }: ActionContext<EventDetailsState, IState>, isMiniScoreboardVisible: boolean) {
            commit('SET_IS_MINI_SCOREBOARD_VISIBLE', isMiniScoreboardVisible);
        },
        setIsSmallVisualisationVisible({ commit }: ActionContext<EventDetailsState, IState>, isSmallVisualisationVisible: boolean) {
            commit('SET_IS_SMALL_VISUALISATION_VISIBLE', isSmallVisualisationVisible);
        },
    },
};

export default eventDetailsStore;

export type EventDetailsStore = typeof eventDetailsStore;
